import { NgModule } from '@angular/core';
import { PhoneComponent } from './phone.component';



@NgModule({
  declarations: [
    PhoneComponent
  ],
  imports: [
  ],
  exports: [
    PhoneComponent
  ]
})
export class PhoneModule { }
